import React, { useCallback, useState, useEffect } from 'react'
import {
	BarChart,
	Bar,
	CartesianGrid,
	XAxis,
	YAxis,
	Legend,
	Tooltip
} from "recharts";
import appUrl from '../../appUrl';
import { toast } from 'react-toastify';

const BookingsPerMonth = () => {
	const AppUrl = appUrl();
	const [ dataLoading, setDataLoading ] = useState(false)
    const [ data, setData ] = useState([])

	const currentMonth = new Date().getMonth();

	const fetchMonthlyBookings = useCallback( async (year) => {
		if(dataLoading) return;
		
		const token = localStorage.getItem("token");
  
		try {
		  setDataLoading(true);
  
		  const response = await fetch(`${AppUrl}/dashboard/monthly-bookings?year=${year}`, {
			method: "GET",
			headers: {
			  Authorization: `Bearer ${token}`,
			},
		  });
  
		  if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		  }
	  
		  const data = await response.json();
	  
		  if (!data.status) {
			throw new Error(data.message || "Some error occurred!");
		  }
  
			setData(
				data.data.map((item, index) => ({
				...item,
				totalBookings: index <= currentMonth ? item.totalBookings : null,
				completedBookings: index <= currentMonth ? item.completedBookings : null,
			})));
  
		} catch (error) {
			console.error(error);
			toast.error(error.message || "Some error occurred!");
		} finally {
		  setDataLoading(false)
		}
	  }, [AppUrl])
  
	  useEffect(() => {
		fetchMonthlyBookings()
	  }, [fetchMonthlyBookings])

	return (
		<div className='py-3 px-3 border shadow-sm' style={{ width: 'fit-content', borderRadius: '25px'}}>
            <h4 className="mb-4">{`Booking Analytics: ${new Date().getFullYear()}`}</h4>
			<BarChart width={1000} height={380} data={data}>
                <CartesianGrid stroke="#ccc" strokeDasharray="3 3" vertical={false} />
				<XAxis dataKey="month" />
				<YAxis />
				<Tooltip />
				<Legend />
				<Bar dataKey="totalBookings" fill="#0088FE" name="Total Bookings" />
				<Bar dataKey="completedBookings" fill="#00C49F" name="Completed Bookings" />
			</BarChart>
		</div>
	);
};

export default BookingsPerMonth;
